import _toConsumableArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import React from "react";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import { useLookups } from "./LookupProvider";
var getCollection = function getCollection(type) {
  switch (type) {
    case "Country":
      return "countries";
    case "State":
      return "states";
    case "Ethnicity":
      return "ethnicities";
    case "Document Type":
      return "documentTypes";
    default:
      throw new Error("Type not supported");
  }
};
var LookupPicker = function LookupPicker(props) {
  var collection = getCollection(props.type);
  var items = useLookups()[collection];
  if (collection === "documentTypes") {
    items = _toConsumableArray(items).sort(function (a, b) {
      var _a, _b;
      return ((_a = a.name) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.name) !== null && _b !== void 0 ? _b : "");
    });
  }
  return React.createElement(FormControl, {
    fullWidth: props.fullWidth
  }, React.createElement(InputLabel, null, "".concat(props.type, " ").concat(props.required ? "*" : "")), React.createElement(Select, Object.assign({
    native: true
  }, props), React.createElement("option", null), items.map(function (item, index) {
    return React.createElement("option", {
      key: index,
      value: item.id
    }, item.name);
  })));
};
export default LookupPicker;